import { getObjectValue } from '@services/object-extensions';
import { JsonResponseParser } from './json-response.parser';

export class CategoriesDetailParser extends JsonResponseParser {
  /**
   * Parses the response into a JSON.
   * @param {*} response
   */
  parse(response) {
    const data = super.parse(response);
    const translations = {
      title: getObjectValue(data, 'title', ''),
      subtitle: getObjectValue(data, 'subtitle', ''),
      paragraph: getObjectValue(data, 'body', ''),
      additionalInfo: getObjectValue(data, 'additionalInfo', [])?.map((el) => ({
        title: getObjectValue(el, 'title', ''),
        body: getObjectValue(el, 'body', '')
      })),
      card: getObjectValue(data, 'succesStories', [])?.map((element) => ({
        title: getObjectValue(element, 'title', ''),
        text: getObjectValue(element, 'body', ''),
        button: getObjectValue(element, 'button', ''),
        href: getObjectValue(element, '_id', '')
      }))
    };
    const darkTheme = getObjectValue(data, 'dark', false);
    const imageUrl = getObjectValue(data, 'imgUrl', '');

    return { translations, imageUrl, darkTheme };
  }
}
